<template>
  <el-table
    ref="elTable"
    :data="data"
    :row-key="rowKeyFn"
    :tree-props="{ children: childrenKey }"
    :default-expand-all="!isFold"
    :border="border"
    :stripe="stripe"
    :highlight-current-row="highlightCurrentRow"
    v-bind="$attrs"
    @row-click="onRowClick"
  >
    <!-- 序号列 -->
    <el-table-column v-if="showIndex" type="index" :label="indexText" width="70" align="center" />
    <el-table-column
      v-for="(col, ci) in columns"
      :key="ci"
      :label="col.label || col.text"
      :prop="col.prop || col.value"
      :width="col.width"
      :min-width="col.minWidth"
      :align="col.align"
      :fixed="col.fixed"
    >
      <template #default="scope">
        <template v-if="col.type === 'template' && $slots[col.template]">
          <slot :name="col.template" v-bind="buildScope(scope)"></slot>
        </template>
        <template v-else>{{ scope.row[col.prop || col.value] }}</template>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
// vue-table-with-tree-grid（Vue2 专属库）的 Vue3 兼容包装组件
// 内部改用 Element Plus 树形表格实现，保持原组件的 props / 插槽 / 事件 API
// 支持 columns 的两种列定义风格：{label, prop} 与 {text, value}；模板列 {type:'template', template:'插槽名'}
export default {
  name: 'TreeTable',
  props: {
    data: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
    // 兼容原库开关参数
    selectionType: { type: Boolean, default: false },
    expandType: { type: Boolean, default: false },
    isFold: { type: Boolean, default: true },
    childrenKey: { type: String, default: 'children' },
    showIndex: { type: Boolean, default: false },
    indexText: { type: String, default: '#' },
    border: { type: Boolean, default: false },
    stripe: { type: Boolean, default: false },
    showRowHover: { type: Boolean, default: true },
    highlightCurrentRow: { type: Boolean, default: false }
  },
  data() {
    return { currentRow: null }
  },
  computed: {
    rowKeyFn() {
      return (row) => row.id || row.Id || row.ID || row.key
    }
  },
  methods: {
    buildScope(scope) {
      // 兼容原库插槽参数 { row, index }
      return { row: scope.row, index: scope.$index }
    },
    onRowClick(row, column, event) {
      this.currentRow = row
      this.$emit('row-click', row, column, event)
    },
    // 兼容 vue-table-with-tree-grid 的实例方法：外部可用 $refs.xxx.rowClick(row) 主动选中某行
    // 原库行为 = 设为当前行（高亮） + 触发 row-click 事件
    rowClick(row, column, event) {
      if (!row) return
      this.currentRow = row
      // EP 树形表格首次渲染阶段（数据刚传入、treeData 还在初始化）setCurrentRow
      // 会被吞掉：内部状态设了但行元素不加 current-row 类。这里设完做校验，
      // 高亮没落上就逐帧重试，直到行元素真正带上 tr.current-row
      const table = this.$refs.elTable
      const apply = (tries) => {
        if (!table || typeof table.setCurrentRow !== 'function') return
        table.setCurrentRow(row)
        this.$nextTick(() => {
          const lit = table.$el && table.$el.querySelector('.el-table__row.current-row')
          if (!lit && tries > 0) requestAnimationFrame(() => apply(tries - 1))
        })
      }
      apply(10)
      this.$emit('row-click', row, column, event)
    }
  }
}
</script>
